// extracted by mini-css-extract-plugin
export default {"card":"CollectionCard_card__OAMYO","imgBox":"CollectionCard_imgBox__EKD4+","content":"CollectionCard_content__BsOaW","tag":"CollectionCard_tag__F90Ik"};